/* tslint:disable */
/* eslint-disable */
/**
 * openapi.yml
 * オンラインCE API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResultCalcAp
 */
export interface ResultCalcAp {
    /**
     * 計算結果区分
     * @type {string}
     * @memberof ResultCalcAp
     */
    resultClass?: string;
    /**
     * 苛性生産量
     * @type {number}
     * @memberof ResultCalcAp
     */
    naohProduction?: number;
    /**
     * 塩素生産量
     * @type {number}
     * @memberof ResultCalcAp
     */
    cl2Production?: number;
    /**
     * 苛性50%中食塩濃度
     * @type {number}
     * @memberof ResultCalcAp
     */
    naclInNaoh50?: number;
    /**
     * 苛性32%中食塩濃度
     * @type {number}
     * @memberof ResultCalcAp
     */
    naclInNaoh32?: number;
    /**
     * 電力
     * @type {number}
     * @memberof ResultCalcAp
     */
    power?: number;
}

/**
 * Check if a given object implements the ResultCalcAp interface.
 */
export function instanceOfResultCalcAp(value: object): value is ResultCalcAp {
    return true;
}

export function ResultCalcApFromJSON(json: any): ResultCalcAp {
    return ResultCalcApFromJSONTyped(json, false);
}

export function ResultCalcApFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultCalcAp {
    if (json == null) {
        return json;
    }
    return {
        
        'resultClass': json['resultClass'] == null ? undefined : json['resultClass'],
        'naohProduction': json['naohProduction'] == null ? undefined : json['naohProduction'],
        'cl2Production': json['cl2Production'] == null ? undefined : json['cl2Production'],
        'naclInNaoh50': json['naclInNaoh50'] == null ? undefined : json['naclInNaoh50'],
        'naclInNaoh32': json['naclInNaoh32'] == null ? undefined : json['naclInNaoh32'],
        'power': json['power'] == null ? undefined : json['power'],
    };
}

export function ResultCalcApToJSON(value?: ResultCalcAp | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'resultClass': value['resultClass'],
        'naohProduction': value['naohProduction'],
        'cl2Production': value['cl2Production'],
        'naclInNaoh50': value['naclInNaoh50'],
        'naclInNaoh32': value['naclInNaoh32'],
        'power': value['power'],
    };
}

